/**
 * Custom Lookbook Carousel JavaScript
 * This script initializes the Swiper slider and handles the product hotspot functionality
 */

document.addEventListener('DOMContentLoaded', function() {
  initLookbookCarousels();
  initHotspots();
});

function initLookbookCarousels() {
  const carousels = document.querySelectorAll('.lookbook-carousel');

  carousels.forEach(carousel => {
    const settings = {
      autoplay: carousel.dataset.autoplay === 'true',
      loop: carousel.dataset.loop === 'true',
      showArrows: carousel.dataset.arrows === 'true',
      showDots: carousel.dataset.dots === 'true',
      desktopItems: parseInt(carousel.dataset.desktopItems || 1),
      mobileItems: parseInt(carousel.dataset.mobileItems || 1),
      autoplayDelay: parseInt(carousel.dataset.delay || 5000)
    };

    new Swiper(carousel, {
      slidesPerView: settings.mobileItems,
      spaceBetween: parseInt(carousel.dataset.columnGap || 20),
      loop: settings.loop,
      grabCursor: true,
      watchSlidesProgress: true,
      breakpoints: {
        750: {
          slidesPerView: settings.desktopItems
        }
      },
      navigation: settings.showArrows ? {
        nextEl: carousel.querySelector('.swiper-button-next'),
        prevEl: carousel.querySelector('.swiper-button-prev'),
      } : false,
      pagination: settings.showDots ? {
        el: carousel.querySelector('.swiper-pagination'),
        clickable: true,
      } : false,
      autoplay: settings.autoplay ? {
        delay: settings.autoplayDelay,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      } : false,
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
        firstSlideMessage: 'This is the first slide',
        lastSlideMessage: 'This is the last slide',
        paginationBulletMessage: 'Go to slide {{index}}'
      }
    });
  });
}

function initHotspots() {
  const hotspots = document.querySelectorAll('.lookbook-hotspot');

  hotspots.forEach(hotspot => {
    const action = hotspot.dataset.hotspotAction;

    hotspot.addEventListener('click', function(e) {
      e.preventDefault();
      if (action === 'popup') {
        document.querySelectorAll('.lookbook-hotspot.active').forEach(active => {
          if (active !== hotspot) active.classList.remove('active');
        });
        hotspot.classList.toggle('active');
        e.stopPropagation();
      } else if (action === 'redirect') {
        const productId = hotspot.dataset.productId;
        window.location.href = '/products/' + productId;
      }
    });
  });

  document.addEventListener('click', function(e) {
    if (!e.target.closest('.lookbook-hotspot') && !e.target.closest('.hotspot-product-popup')) {
      document.querySelectorAll('.lookbook-hotspot.active').forEach(active => {
        active.classList.remove('active');
      });
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.lookbook-hotspot.active').forEach(active => {
        active.classList.remove('active');
      });
    }
  });
}

window.addEventListener('resize', function() {
  const activeHotspots = document.querySelectorAll('.lookbook-hotspot.active');
  if (activeHotspots.length > 0) {
    activeHotspots.forEach(hotspot => {
      hotspot.classList.remove('active');
      void hotspot.offsetWidth;
      hotspot.classList.add('active');
    });
  }
});
